import type { ComponentPropsWithRef } from 'react'

export const kind = 'ms__CheckBoxGroupItem' as const

export default function CheckboxItem(props: ComponentPropsWithRef<'div'>) {
  return <div data-component={kind} {...props} />
}
